import {useEffect, useState} from 'react'
import {ISelectOption} from '../utils/core/_model'
import axios from 'axios'
import {GET_LINKS_URL} from '../modules/menu-management/link/LinkList'
import {ILink} from '../modules/menu-management/link/_modal'

const useLinkList = () => {
  const [optionsLink, setOptionsLink] = useState<ISelectOption[]>([])
  const [options, setOptions] = useState<ILink[]>([])

  useEffect(() => {
    const getLinkList = async () => {
      try {
        const response = await axios.get<{data: ILink[]}>(GET_LINKS_URL)
        const data = await response.data
        const result = await data.data
        const formatted = result.map((link) => ({
          id: link.link_id,
          value: link.link_name,
          label: link.link_name,
        }))
        setOptionsLink(formatted || [])
        setOptions(result || [])
      } catch (error) {
        console.log(error)
      }
    }

    getLinkList()
  }, [])

  return {
    optionsLink,
    options,
  }
}

export default useLinkList
